import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { authHelper } from "../Helpers/authHelper";

const ProtectedRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading state

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authHelperInstance = new authHelper();
        const currentUser = await authHelperInstance.getCurrentUser();

        // Check if the user object exists and has valid properties
        if (currentUser && currentUser.uid && currentUser.uid !== "") {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  // Show a loading state while authentication is being checked
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default ProtectedRoute;